<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">Strain</h4>
          <a href="/help/knowledgebase?section=strain" target="_blank">
            <img src="/img/icons/ic_info.svg" alt="About Strain" class="ms-2" /></a>
        </div>
        <div>
          <Datepicker id="dpStrain" v-model="dtRange" dark range auto-range="6" :format="dtRangeFormat"
            :enable-time-picker="false" :max-date="new Date()" />
        </div>
      </div>

      <div class="col-12 mt-3">
        <strain-by-day-section-chart v-if="chart" id="chart" header="Strain Ranges" :period="dtRange"
          title="All Sections" height="480" :data-strain-ranges="dataStrainRanges" :data-strain="dataStrain"
          :chart="chart" :selected-section-id="selectedSection" @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)
          " @selected-page="(selectedValue) => (page = selectedValue)"
          @selected-sort="(selectedValue) => (sort = selectedValue)"
          @selected-order="(selectedValue) => (order = selectedValue)" :selected-platoon-id="selectedPlatoon"
          @selected-platoon-id="
            (selectedValue) => (selectedPlatoon = selectedValue)
          " />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <strain-section-workouts-chart v-if="chartWorkouts" id="chartWorkouts"
          header="Max Heart Rate and Active Calories" :period="dtRange" title="ALPHA: All Workouts" height="480"
          :data-workout-types="dataWorkoutTypes" :data-workouts="dataWorkouts" :chart="chartWorkouts"
          :selected-workout-type-id="selectedWorkoutType" :selected-section-id="selectedSection"
          @selected-workout-type-id="
            (selectedValue) => (selectedWorkoutType = selectedValue)
          " @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)
          " @selected-page="(selectedValue) => (pageWorkouts = selectedValue)"
          @selected-sort="(selectedValue) => (sortWorkouts = selectedValue)"
          @selected-order="(selectedValue) => (orderWorkouts = selectedValue)" />
      </div>
    </div>
  </div>
</template>
<script>
const dayjs = require("dayjs");
import Constants from "@/helpers/constants";
import ChartUtils from "@/helpers/chartUtils";
import Datepicker from "@vuepic/vue-datepicker";
import StrainByDaySectionChart from "./components/StrainByDaySectionChart.vue";
import StrainSectionWorkoutsChart from "./components/StrainSectionWorkoutsChart.vue";

export default {
  name: "Strain",
  components: {
    StrainByDaySectionChart,
    StrainSectionWorkoutsChart,
    Datepicker,
  },
  data() {
    return {
      dtRangeFormat: Constants.DATE_RANGE_FORMAT,
      dtRange: [dayjs().subtract(6, "days"), dayjs()],
      page: Constants.DEFAULT_PAGE,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      sort: "bucket",
      order: "desc",
      pageWorkouts: Constants.DEFAULT_PAGE,
      pageSizeWorkouts: Constants.DEFAULT_PAGE_SIZE,
      sortWorkouts: "workout_record_start_time",
      orderWorkouts: "desc",
      selectedSection: Constants.DEFAULT_SECTION,
      selectedWorkoutType: Constants.DEFAULT_WORKOUT_TYPE,
      dataStrainRanges: [],
      dataStrain: [],
      dataStrainAvgMaxHr: [],
      dataWorkoutTypes: [],
      dataWorkouts: [],
      chart: {
        labels: [],
        datasets: [],
      },
      chartWorkouts: {
        labels: [],
        datasets: [],
      },
      selectedPlatoon: Constants.DEFAULT_PLATOON,
    };
  },
  watch: {
    dtRange() {
      if (!this.dtRange) {
        this.dtRange = [dayjs().subtract(6, "days"), dayjs()];
      }

      this.getDataStrainRanges();
      this.getDataStrainAvgMaxHr();
    },
    selectedSection() {
      this.getDataStrainRanges();
      this.getDataStrainAvgMaxHr();
    },
    selectedPlatoon() {
      this.getDataStrainRanges();
      this.getDataStrainAvgMaxHr();
    },
    selectedWorkoutType(newValue) {
      this.getWorkoutsBySection(newValue);
    },
    page() {
      this.getDataStrain();
    },
    sort() {
      this.getDataStrain();
    },
    order() {
      this.getDataStrain();
    },
    pageWorkouts() {
      this.getWorkoutsBySection(this.selectedWorkoutType);
    },
    sortWorkouts() {
      this.getWorkoutsBySection(this.selectedWorkoutType);
    },
    orderWorkouts() {
      this.getWorkoutsBySection(this.selectedWorkoutType);
    },
  },
  mounted() {
    this.getDataStrainRanges();
    this.getDataStrainAvgMaxHr();
  },
  methods: {
    getDataStrainRanges() {
      this.$store
        .dispatch("data/strainRangesBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
          platoon_id: this.selectedPlatoon
        })
        .then((data) => {
          this.dataStrainRanges = data.data;
          this.updateChartData();
          this.getDataStrain();
        });
    },
    getDataStrain() {
      this.$store
        .dispatch("data/strainDataBySection", {
          page: this.page,
          page_size: this.pageSize,
          sort: this.sort,
          order: this.order,
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataStrain = data.data;
        });
    },
    getDataStrainAvgMaxHr() {
      this.$store
        .dispatch("data/strainAvgMaxHrBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataStrainAvgMaxHr = data.data;
          this.updateWorkoutsChartData();
          this.getWorkoutTypesBySection();
        });
    },
    getWorkoutTypesBySection() {
      this.$store
        .dispatch("data/strainWorkoutTypesBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((data) => {
          this.dataWorkoutTypes = data.data;
          // Auto select first workout type
          this.selectedWorkoutType =
            this.dataWorkoutTypes.length > 0
              ? this.dataWorkoutTypes[0].workout_type_record.workout_type_id
              : -1;
        });
    },
    getWorkoutsBySection(workoutType) {
      this.$store
        .dispatch("data/strainWorkoutsBySection", {
          page: this.pageWorkouts,
          page_size: this.pageSizeWorkouts,
          sort: this.sortWorkouts,
          order: this.orderWorkouts,
          section_id: this.selectedSection || -1,
          workout_type: workoutType || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((data) => {
          this.dataWorkouts = data.data;
        });
    },
    updateChartData() {
      this.chart = Object.assign(
        {},
        ChartUtils.dataRangesChart(this.dataStrainRanges)
      );
    },
    updateWorkoutsChartData() {
      this.chartWorkouts = Object.assign(
        {},
        ChartUtils.avgMaxHrChart(this.dataStrainAvgMaxHr)
      );
    },
  },
};
</script>
